<template>
    <div class="modal_cont">
        <div class="modal_header">
            <a href="#none" @click="closeModal" class="btn_close">닫기</a>
        </div>

        <div class="modal_content">
            <div class="board_detail_wrap">
                <div class="detail_title">
                    <strong class="tit">{{ notice.notiTitle }}</strong>
                    <p class="info">
                        <em>{{ categoryName }}</em>
                        <span class="date">{{ displayDate }}</span>
                    </p>
                </div>

                <div class="board_detail_cont" v-html="noticeContent"></div>
            </div>
        </div>
        <div v-if ="notice.orgFileNm" @click="handleDownload()">{{notice.orgFileNm}}</div>
    </div>
</template>

<script>
import modal from "@/utils/popupModal";
import { API } from "@/api";
import { COMM_CD_GROUP_IDS, loadCommCdGroupItems } from "@/utils/CommonCode.js";
import { fileAPIDgshp } from "@/api/fileAPI.js";
import { makeUrlForBlob, SaveToDisk } from "@/utils/File.js";

export default {
    name: "instoreBoardDetail",
    components: {},
    props: {
        lang: { type: String, default: "ko" },
        noticeNo: { type: [String, Number], default: "" }
    },
    data() {
        return {
            notice: {
                istrNotiSeqno: "",
                istrNotiBzDvCd: "",
                notiTitle: "",
                ntcMatrCntnt: "",
                regDttm: ""
            },
            bzDvCdItems: [],
            isLoading: false
        };
    },
    computed: {
        categoryName() {
            const bzDvCd = this.notice.istrNotiBzDvCd;
            const codeItem = this.bzDvCdItems.find((item) => String(item.value) === String(bzDvCd));

            return codeItem?.title || bzDvCd || "공지사항";
        },
        displayDate() {
            return this.formatDate(this.notice.regDttm || this.notice.bltBeginDt || this.notice.date || "");
        },
        noticeContent() {
            return this.notice.ntcMatrCntnt || this.notice.notiCntnt || this.notice.cntnt || this.notice.cntnsCntnt || "";
        }
    },
    mounted() {
        const header = document.getElementById("header");

        header?.classList.add("head_black");
        this.initBoardDetail();
    },
    methods: {
        closeModal(event) {
            modal.close(event.currentTarget);
        },
        async initBoardDetail() {
            await Promise.all([
                this.loadBzDvCdItems(),
                this.getInstoreNotice()
            ]);
        },
        async loadBzDvCdItems() {
            const codeSelectItems = await loadCommCdGroupItems({
                bzDvCdItems: COMM_CD_GROUP_IDS.BZ_DV_CD
            });

            this.bzDvCdItems = codeSelectItems.bzDvCdItems;
        },
        async getInstoreNotice() {
            if (!this.noticeNo) return;

            this.isLoading = true;

            try {
                const response = await API.instoreAPI.getInstoreNotice({ istrNotiSeqno: this.noticeNo });
                this.notice = this.getNoticeData(response?.data);
            } catch (error) {
                console.error("Instore notice detail error:", error);
                this.notice = {
                    istrNotiSeqno: "",
                    istrNotiBzDvCd: "",
                    notiTitle: "",
                    ntcMatrCntnt: "",
                    regDttm: "",
                    filePathNm:"",
                    orgFileNm:""
                };
            } finally {
                this.isLoading = false;
            }
        },
        async handleDownload() {
            if (!this.notice?.filePathNm) return;

            try {
                const fileInfo = {
                    uploadPath: this.notice.filePathNm,
                    orgFilename: this.notice.orgFileNm 
                };
                const response = await fileAPIDgshp.fileDownloadApi(fileInfo);

                SaveToDisk(makeUrlForBlob(response.data), fileInfo.orgFilename);
            } catch (error) {
                console.error("파일 다운로드 오류:", error);
                alert("처리중 오류가 발생했습니다.");
            }
        },
        getNoticeData(data) {
            if (!data) return {};
            if (data.result && !Array.isArray(data.result)) return data.result;
            if (data.data && !Array.isArray(data.data)) return data.data;

            return data;
        },
        formatDate(value) {
            if (!value) return "";

            const date = new Date(value);
            if (Number.isNaN(date.getTime())) return String(value).slice(0, 10).replaceAll("-", ".");

            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");

            return `${year}.${month}.${day}`;
        }
    }
};
</script>

<style scoped>
.btnSection.bottom {margin-top:20px; display:flex; justify-content:space-between;}
.btnSection.bottom .btn_icon_back {height:auto; padding:4px; color:#161616; font-size:2rem; line-height:135%; letter-spacing:-0.01em; background-color:#fff; display:inline-flex; align-items:center;}
.btnSection.bottom .btn_icon_back:before {width:16px; height:27px; margin-right:12px; background-color:red; content:''; display:block;}
.board_detail_cont { width: 100%; }
:deep(.board_detail_cont > p) { width: 100%; margin: 0 0 12px; color: #67676f; font-size: 2rem; font-weight: 400; line-height: 1.35; letter-spacing: -0.01em; }
:deep(.board_detail_cont > p:empty) { min-height: 1.35em; }
:deep(.board_detail_cont > p:empty::before) { content: "\00a0"; }
:deep(.board_detail_cont blockquote) { margin: 12px 0; padding-left: 14px; border-left: 3px solid #b9c5d8; color: #586575; }
:deep(.board_detail_cont code) { padding: 2px 5px; border-radius: 3px; background: #eef1f5; font-family: Consolas, monospace; }
:deep(.board_detail_cont pre) { padding: 12px; border-radius: 4px; background: #26313d; color: #f7f9fb; overflow-x: auto; }
:deep(.board_detail_cont ul),
:deep(.board_detail_cont ol) { padding-left: 24px; }
:deep(.board_detail_cont a) { color: #1f56c5; text-decoration: underline; }
:deep(.board_detail_cont img) { max-width: 100%; height: auto; }
:deep(.board_detail_cont table) { width: 100%; margin: 12px 0; border-collapse: collapse; table-layout: fixed; }
:deep(.board_detail_cont th),
:deep(.board_detail_cont td) { min-width: 1em; padding: 8px; border: 1px solid #b8c0cc; vertical-align: top; }
:deep(.board_detail_cont th) { background: #edf1f5; font-weight: 700; }

@media screen and (max-width: 1024px) {
}
@media screen and (max-width: 767px) {
    :deep(.board_detail_cont > p) { font-size: 1.6rem; line-height: 1.5; }
}
</style>
